import { render } from "./BlockView.vue?vue&type=template&id=8577383a&scoped=true"
const script = {}

import "./BlockView.vue?vue&type=style&index=0&id=8577383a&scoped=true&lang=sass"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8577383a"]])

export default __exports__